// extracted by mini-css-extract-plugin
module.exports = {"page-loading-layer":"PageLoadingLayer_page-loading-layer__2DNB8","spinner":"PageLoadingLayer_spinner__2skCx","spin":"PageLoadingLayer_spin__1Un-m"};